<template>
  <div>
    <v-snackbar absolute top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="$store.state.search"
      :items-per-page="10"
      :loading="loading"
      class="pl-5 pr-5"
      :sort-by="['name']"
      :sort-desc="true"
      item-key=".key"
      fixed-header
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100, 250],
      }"
    >
      <template v-slot:[`item.image`]="{ item }">
        <img
          class="image"
          @click="$emit('menuClick', { action: 0, item })"
          :src="
            item.screenshot ||
            (item.image && item.image.original
              ? item.image.original
              : defaultImage)
          "
          :alt="item.name"
        />
      </template>

      <template v-slot:[`item.agencyImage`]="{ item }">
        <img
          class="image"
          @click="$emit('menuClick', { action: 0, item })"
          :src="item.image ? item.image.original : defaultImage"
          :alt="item.name"
        />
      </template>

      <template v-slot:[`item.productImage`]="{ item }">
        <img
          class="image"
          @click="$emit('menuClick', { action: 0, item })"
          :src="item.images.length ? item.images[0].url : defaultImage"
        />
      </template>

      <template v-slot:[`item.name`]="{ item }">
        <div class="description">
          {{ item.name }}
        </div>
      </template>

      <template v-slot:[`item.role`]="{ item }">
        <div class="description">
          {{ item.role | filterRole }}
        </div>
      </template>

      <template v-slot:[`item.color`]="{ item }">
        <div class="color" :style="`background-color:${item.color}`">
          {{ item.color }}
        </div>
      </template>

      <template v-slot:[`item.price`]="{ item }">
        <v-chip>
          {{ item.price | currency }}
        </v-chip>
      </template>

      <template v-slot:[`item.items`]="{ item }">
        <v-chip class="ml-3" :key="index" v-for="(data, index) of item.items">
          {{ data }}
        </v-chip>
      </template>

      <template v-slot:[`item.characteristics`]="{ item }">
        <div class="characteristics">
          <span
            class="ml-3"
            :key="index"
            v-for="(data, index) of item.characteristics"
          >
            {{ data.name }} : {{ data.value }} ,
          </span>
        </div>
      </template>

      <!-- characteristics -->

      <template v-slot:[`item.extension`]="{ item }">
        <v-chip>
          {{ item.extension }}
        </v-chip>
      </template>

      <template v-slot:[`item.duration`]="{ item }">
        {{ item.duration | filterDuration }} min
      </template>

      <template v-slot:[`item.products`]="{ item }">
        {{ item.products ? item.products.length : 0 }}
      </template>

      <template v-slot:[`item.description`]="{ item }">
        <div class="description">
          {{ item.description }}
        </div>
      </template>

      <template v-slot:[`item.filesCount`]="{ item }">
        <v-chip>
          {{ item.files.length }}
        </v-chip>
      </template>

      <template v-slot:[`item.imageDuration`]="{ item }">
        {{ `${item.imageDuration} seg.` }}
      </template>

      <template v-slot:[`item.visibleCategories`]="{ item }">
        {{ item.visibleCategories.length || 0 }}
      </template>

      <template v-slot:[`item.active`]="{ item }">
        <v-switch
          :loading="loading"
          @change="$emit('activeChange', item)"
          v-model="item.active"
        ></v-switch>
      </template>

      <template v-slot:[`item.agencies`]="{ item }">
        {{ item.agencies ? item.agencies.length : 0 }}
      </template>

      <template v-slot:[`item.visibleSubcategories`]="{ item }">
        {{ item.visibleSubcategories.length || 0 }}
      </template>

      <template v-slot:[`item.bannerDuration`]="{ item }">
        {{ `${item.duration} seg.` }}
      </template>

      <template v-slot:[`item.createdAt`]="{ item }">
        {{ item.createdAt | filterDate }}
      </template>

      <template v-slot:[`item.aspect`]="{ item }">
        {{ item.aspect | aspectRatio }}
      </template>

      <template v-slot:[`item.startDate`]="{ item }">
        {{ item.startDate | filterDate }}
      </template>

      <template v-slot:[`item.endDate`]="{ item }">
        {{ item.endDate | filterDate }}
      </template>

      <template v-slot:[`item.size`]="{ item }">
        {{ item.size | filterSize }}
      </template>

      <template v-slot:[`item.email`]="{ item }">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-chip
              color="rgba(0, 0, 0, 0.1)"
              style="display: inline-block"
              v-on="on"
              :text-color="$vuetify.theme.dark ? 'white' : 'black'"
              @click="copyToClipboard(item.email)"
              >{{ item.email }}</v-chip
            >
          </template>
          <i class="far fa-copy mr-2"></i>
          <span>Click para copiar</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.options`]="{ item }">
        <v-tooltip v-if="showAddApps" left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              v-on="on"
              :loading="loading"
              @click="$emit('menuClick', { action: 0, item })"
              dark
              x-small
              :elevation="0"
              color="rgba(0, 0, 0, 0.6)"
            >
              <v-icon dark>fa-building</v-icon>
            </v-btn>
          </template>
          <span>Asignar sucursales</span>
        </v-tooltip>

        <v-tooltip v-if="showAddAgencies" left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              v-on="on"
              :loading="loading"
              @click="$emit('menuClick', { action: 0, item })"
              dark
              x-small
              :elevation="0"
              color="rgba(0, 0, 0, 0.6)"
            >
              <v-icon dark>fa-building</v-icon>
            </v-btn>
          </template>
          <span>Asignar sucursales</span>
        </v-tooltip>

        <v-tooltip v-if="showInfo" left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              v-on="on"
              :loading="loading"
              @click="$emit('menuClick', { action: 3, item })"
              dark
              x-small
              :elevation="0"
              color="rgba(0, 0, 0, 0.6)"
            >
              <v-icon dark>fa-info</v-icon>
            </v-btn>
          </template>
          <span>Ver información</span>
        </v-tooltip>

        <v-tooltip v-if="showAddImage" left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              v-on="on"
              :loading="loading"
              @click="$emit('menuClick', { action: 0, item })"
              dark
              x-small
              :elevation="0"
              color="rgba(0, 0, 0, 0.6)"
            >
              <v-icon dark>fa-image</v-icon>
            </v-btn>
          </template>
          <span>Cambiar imagen</span>
        </v-tooltip>

        <v-tooltip v-if="showList" left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              v-on="on"
              :loading="loading"
              @click="$emit('menuClick', { action: 3, item })"
              dark
              x-small
              :elevation="0"
              color="rgba(0, 0, 0, 0.6)"
            >
              <v-icon dark>fas fa-list</v-icon>
            </v-btn>
          </template>
          <span>Lista</span>
        </v-tooltip>

        <v-tooltip v-if="showView" left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              v-on="on"
              @click="$emit('menuClick', { action: 0, item })"
              dark
              :loading="loading"
              x-small
              :elevation="0"
              color="rgba(0, 0, 0, 0.6)"
            >
              <v-icon dark>fa-eye</v-icon>
            </v-btn>
          </template>
          <span>Ver archivo</span>
        </v-tooltip>

        <v-tooltip v-if="showEdit" left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              v-on="on"
              :loading="loading"
              @click="$emit('menuClick', { action: 1, item })"
              dark
              x-small
              :elevation="0"
              color="rgba(0, 0, 0, 0.6)"
            >
              <v-icon dark>fa-pencil-alt</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip v-if="showDelete" left>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              fab
              :loading="loading"
              v-on="on"
              @click="$emit('menuClick', { action: 2, item })"
              dark
              x-small
              :elevation="0"
              color="red darken-4"
            >
              <v-icon dark>fa-trash</v-icon>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>

      <template v-slot:loading>
        <v-skeleton-loader
          ref="skeleton"
          type="table-tbody"
          class="mx-auto d-none d-md-block"
        >
        </v-skeleton-loader>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

export default {
  props: [
    "headers",
    "items",
    "loading",
    "showView",
    "showEdit",
    "showDelete",
    "showInfo",
    "showList",
    "showAddImage",
    "showAddAgencies",
    "showAddApps",
  ],
  name: "files-table",
  data() {
    return {
      defaultImage: require("@/assets/wink-placeholder.png"),
      snackbarText: "",
      snackbar: false,
    };
  },
  filters: {
    filterSize(size) {
      return `${(size / 1048576).toFixed(2)} MB`;
    },
    filterRole(code) {
      let roles = {
        sa: "Super usuario",
        su: "Supervisor",
        ed: "Editor",
      };
      return code ? roles[code] : "";
    },
    currency: function (amount) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HNL",
        minimumFractionDigits: 2,
      });
      return formatter.format(amount);
    },

    aspectRatio(index) {
      let aspect = ["4:3", "5:4", "16:9", "16:10"];
      return aspect[index];
    },

    filterDate(timestamp) {
      if (!timestamp) return "";
      return moment(timestamp.toDate()).tz("America/Tegucigalpa").format("LL");
    },
    filterDuration(duration) {
      let result = 0;
      if (duration) {
        let minutes = parseInt(duration / 60);
        let seconds = parseInt(duration % 60);

        result = `${minutes}:${seconds}`;
      }

      return result;
    },
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(
        () => {
          this.snackbar = true;
          this.snackbarText = "Copiado al portapapeles";
        },
        (err) => {
          console.error("Async: Could not copy text: ", err);
        }
      );
    },
  },
};
</script>

<style scoped>
.name {
  background: linear-gradient(to right, #00000079, #00000027, #0000000a);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ellipsis {
  position: absolute;
  cursor: pointer;
  top: 20px;
  right: 0;
  color: white;
  font-weight: bold;
  font-size: 25px;
  width: 50px;
  height: 50px;
  text-align: center;
}

.v-card > :first-child:not(.v-btn):not(.v-chip),
.v-card > .v-card__progress + :not(.v-btn):not(.v-chip) {
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  -webkit-box-shadow: 3px 6px 15px 1px#494949;
  box-shadow: 3px 6px 15px 1px#494949;
}

.image {
  object-fit: cover;
  cursor: pointer;
  max-width: 90%;
  min-width: 90%;
  /* margin: 10px 0 10px 0; */
  max-height: 80px;
  min-height: 80px;
  margin-top: 5px;
}

.description {
  white-space: nowrap;
  max-width: 200px;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.characteristics {
  white-space: nowrap;
  max-width: 450px;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.color {
  padding: 5px;
  color: white;
  text-align: center;
  border-radius: 5px;
  font-weight: bold;
}
</style>